import React, { useEffect, useState } from 'react'
import { BiSearch } from 'react-icons/bi'

const ChatGifPane = ({ open, onPick }) => {
  const [query, setQuery] = useState('')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    let cancelled = false
    const handle = window.setTimeout(async () => {
      setLoading(true)
      try {
        const q = query.trim()
        const res = await fetch(`/api/cn/gifs${q ? `?q=${encodeURIComponent(q)}` : ''}`)
        const type = res.headers.get('content-type') || ''
        const data = type.includes('json') ? await res.json() : { items: [] }
        if (!cancelled) setItems(Array.isArray(data.items) ? data.items : [])
      } catch (_) {
        if (!cancelled) setItems([])
      } finally {
        if (!cancelled) setLoading(false)
      }
    }, query.trim() ? 280 : 0)
    return () => {
      cancelled = true
      window.clearTimeout(handle)
    }
  }, [open, query])

  return (
    <div className={`chatGifPane${open ? ' isOpen' : ''}`} aria-hidden={!open}>
      <div className="chatGifSearch">
        <BiSearch />
        <input
          value={query}
          onChange={event => setQuery(event.target.value)}
          placeholder="Search GIFs"
          aria-label="Search GIFs"
        />
      </div>
      <div className="chatGifGrid">
        {loading && items.length === 0 ? <p className="chatGifHint">Loading GIFs…</p> : null}
        {!loading && items.length === 0 && open ? <p className="chatGifHint">No GIFs found</p> : null}
        {items.map(item => (
          <button
            type="button"
            key={item.id}
            className="chatGifCell"
            onClick={() => onPick(item.url)}
          >
            <img src={item.preview} alt="" />
          </button>
        ))}
      </div>
    </div>
  )
}

export default ChatGifPane
